/**
 * Image imports for external pages only
 * This file is isolated from the main shared folder to prevent
 * pulling in unnecessary dependencies for external routes
 */

// Logo variants
import starBall from '../../../../public/logos/star_ball.png';
import starBallFinal from '../../../../public/logos/star_ball_final.png';
import starBallV2 from '../../../../public/logos/star_ball_v2.png';
import ballOnly from '../../../../public/logos/BallOnly.png';
import voleyT from '../../../../public/logos/voleyT.png';

// Partner logos
import hawkSoftLogo from '../../../../public/logos/HawkSoft_logo_long.png';
import agencyZoomLogo from '../../../../public/logos/agencyzoom_long.png';
import appliedEpicLogo from '../../../../public/logos/Applied_epic.png';


// Testimonial profile images
import keystoneTestimonial from '../../../../public/testimonial_profiles/keystone_testimonial.jpeg';
import doRightTestimonial from '../../../../public/testimonial_profiles/doRight_testimonial.jpeg';
import metroTestimonial from '../../../../public/testimonial_profiles/metro_testimonial.jpeg';
import homesteadTestimonial from '../../../../public/testimonial_profiles/homestead_testimonial.jpeg';
import guardianTestimonial from '../../../../public/testimonial_profiles/guardian_testimonial.jpeg';
import pacificshieldTestimonial from '../../../../public/testimonial_profiles/pacificshield_testimonial.jpeg';

// Team headshots for about page
import johnHeadshot from '../../../../public/team_headshots/1726759606680.jpg';
// Temporarily commented out due to import issue
// import jaredHeadshot from '../../../../public/team_headshots/IMG_7431.JPG';
const jaredHeadshot = '/team_headshots/IMG_7431.JPG';
import brentHeadshot from '../../../../public/team_headshots/1742851573069.jpg';
import jerrisHeadshot from '../../../../public/team_headshots/1740181720927.jpg';

export const logos = {
  // Main logo variants
  starBall,
  starBallFinal,
  starBallV2,
  ballOnly,
  voleyT,
  
  // Partner logos
  hawkSoft: hawkSoftLogo,
  agencyZoom: agencyZoomLogo,
  appliedEpic: appliedEpicLogo,
};

export const testimonialImages = {
  keystone: keystoneTestimonial,
  doRight: doRightTestimonial,
  metro: metroTestimonial,
  homestead: homesteadTestimonial,
  guardian: guardianTestimonial,
  pacificshield: pacificshieldTestimonial,
};

export const teamImages = {
  john: johnHeadshot,
  jared: jaredHeadshot,
  brent: brentHeadshot,
  jerris: jerrisHeadshot,
};

// Default logo export for convenience
export default logos.starBall;